import React, { useEffect, useState } from 'react'
import "./login-rev.css"
import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import { FaEye, FaEyeSlash, FaUser, FaLock } from 'react-icons/fa';
import { postLogin } from '../../api-services/employee-services';
import ForgotPassword from '../../componant/forgot-password/forgot-password';
import { SnackbarService } from '../../services/snackBehaviorSubject/snackBehaviorSubject';
import ModalWrapper from '../../widgets/modal/modal';
import { TokenService } from '../../services/token.service';
import { Role } from '../../model/token-model/role.model';

interface LoginCredentials {
    username: string;
    password: string;
}

const LoginRev = () => {
    const snackbarService = SnackbarService()
    const navigate = useNavigate()
    const loginToken = TokenService.getToken()

    const [openModal, setOpen] = useState<boolean>(false);
    const [credentials, setCredentials] = useState<LoginCredentials>({
        username: '',
        password: '',
    });
    const [showPassword, setShowPassword] = useState<boolean>(false);

    const handleOpen = (e: React.MouseEvent) => {
        e.preventDefault()
        setOpen(true)
    };
    const handleClose = () => setOpen(false);
    const togglePasswordVisibility = () => setShowPassword((prev) => !prev);

    useEffect(() => {
        if (loginToken !== null) {
            checkTokenExpiration()
        } else {
            navigate('/')
        }
    }, [loginToken])

    function checkTokenExpiration() {
        const isExpire = TokenService.isExpired()
        const role = TokenService.getRole()
        if (!isExpire) {
            navigate(role === Role.ADMIN ? '/admin/dashboard' : '/user/dashboard');
        } else {
            navigate('/')
        }
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setCredentials((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        const loginData = {
            username: credentials.username.trim(),
            password: credentials.password
        }
        TokenService.clearToken()
        postLogin(loginData).then((response: any) => {
            if (response?.data.success) {
                TokenService.setToken(response.data.payload)
                navigate(TokenService.getRole() === Role.ADMIN ? '/admin/dashboard' : '/user/dashboard');
            } else {
                snackbarService.next({ data: { open: true, severity: 'error', message: response?.data.message } })
            }
        }).catch();
    };

    return (
        <div className='login-rev-main'>
            <div className="login-rev-card">
                <div className="login-rev-form-side">
                    <h2 className="login-rev-title">Welcome back</h2>
                    <p className="login-rev-subtitle">Sign in to continue to your dashboard</p>

                    <form onSubmit={handleSubmit} className="login-rev-form">
                        <div className="login-rev-field">
                            <FaUser className="login-rev-field-icon" />
                            <input
                                type="text"
                                name="username"
                                placeholder="Username"
                                value={credentials.username}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="login-rev-field">
                            <FaLock className="login-rev-field-icon" />
                            <input
                                type={showPassword ? 'text' : 'password'}
                                name="password"
                                placeholder="Password"
                                value={credentials.password}
                                onChange={handleChange}
                                required
                            />
                            {showPassword ? (
                                <FaEyeSlash className="login-rev-toggle-password" onClick={togglePasswordVisibility} />
                            ) : (
                                <FaEye className="login-rev-toggle-password" onClick={togglePasswordVisibility} />
                            )}
                        </div>

                        <button type="submit" className="login-rev-submit-btn">Login</button>

                        <button type="button" className="login-rev-forgot-btn" onClick={handleOpen}>
                            Forgot password?
                        </button>
                    </form>

                    <ModalWrapper open={openModal} close={handleClose} children={<ForgotPassword onClose={handleClose} />} />
                </div>

                <div className="login-rev-info-side">
                    <div className="login-rev-info-content">
                        <div className="login-rev-info-logo-wrap">
                            <img className="login-rev-info-logo" src={require('../../assets/logo/logo.png')} alt="AirLegit" />
                        </div>
                        <p>
                            AirLegit© enables companies to improve their travelers' end-to-end journeys.
                            We work with airlines, online travel agencies, travel management companies
                            and travel technology innovators to improve their customer experience and
                            generate additional ancillary revenue.
                        </p>
                        <Link to="https://airlegit.com" target="_blank" className="login-rev-readmore-btn">
                            Read More
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LoginRev
